import {ReactPlugin} from "@microsoft/applicationinsights-react-js";
import {ApplicationInsights} from "@microsoft/applicationinsights-web";
import history from "history/browser";

import {version} from "../../package.json";

// App Insights 초기화 여부
let appInsightsInitialized = false;

export const reactPlugin = new ReactPlugin();
export const appInsights = new ApplicationInsights({
  config: {
    // <App /> 을 통해 Server Side에서 주입받습니다.
    // connectionString은 런타임에 주입됩니다.
    extensions: [reactPlugin],
    extensionConfig: {
      // history@5에서 사용법이 변경되었습니다.
      // https://github.com/remix-run/history/blob/main/docs/getting-started.md
      [reactPlugin.identifier]: {
        history: history,
      },
    },
    disableAjaxTracking: true,
    disableFetchTracking: true,
  },
});

// 전역 속성 설정 등록 함수
// SDK가 로드된 이후에 등록해야 하므로 초기화 이후에 호출됩니다.
function registerTelemetryInitializer() {
    try {
        appInsights.addTelemetryInitializer((item: any) => {
            try {
                // 가능한 다양한 텔레메트리 타입을 포괄적으로 처리
                const anyItem: any = item;
                const data = anyItem?.data?.baseData ?? anyItem?.baseData;
                if (data) {
                    data.properties = data.properties || {};
                    data.properties.Version = version;
                }
            } catch {
                // initializer 내부 오류는 앱 동작에 영향 주지 않음
            }
        });
    } catch (e) {
        console.warn("[AppInsights] 텔레메트리 이니셜라이저 등록 실패:", e);
    }
}

/**
 * App Insights 연결 문자열을 설정합니다.
 * @param connectionString 연결 문자열
 */
export function setAppInsightsConnectionString(connectionString: string) {
    // 이미 초기화되었다면 재초기화를 방지합니다.
    if (appInsightsInitialized) return;

    // 유효하지 않은 입력은 경고 후 무시합니다.
    if (!connectionString) {
        console.warn("[AppInsights] 유효하지 않은 connection string입니다.");
        return;
    }

    // 연결 문자열에서 토큰을 파싱하여 instrumentationKey가 있으면 명시적으로 설정합니다.
    try {
        // 정규화된 값으로 설정
        appInsights.config.connectionString = String(connectionString)
            .trim()
            .replace(/^['"]|['"]$/g, "")
            .replace(/\r?\n/g, "");

        const tokens = (appInsights.config.connectionString as string).split(";").filter(Boolean);
        const kv: Record<string, string> = {};

        for (const t of tokens) {
            const idx = t.indexOf("=");
            if (idx > 0) {
                const k = t.substring(0, idx).trim();
                const v = t.substring(idx + 1).trim();
                kv[k] = v;
            }
        }

        if (kv["InstrumentationKey"]) {
            (appInsights.config as any).instrumentationKey = kv["InstrumentationKey"];
        } else {
            console.warn("[AppInsights] connection string does not contain InstrumentationKey token");
        }
    } catch (parseErr) {
        console.warn("[AppInsights] connection string token parse failed:", parseErr);
    }

    try {
        appInsights.loadAppInsights();
        appInsightsInitialized = true;

        // 초기화 이후 전역 텔레메트리 이니셜라이저 등록
        registerTelemetryInitializer();
    } catch (e) {
        console.warn("[AppInsights] 초기화 실패:", e, { provided: connectionString });
    }
}

// TODO: TTI 측정 기능 재검토

// /**
//  * Time to Interactive
//  */
// const metricTTIKey = "TTI";

// let ttiCheckMetrics: boolean = false;
// let timerStarted: boolean = false;
// let ttiStartTime: number = 0;
// let ttiEndTime: number = 0;
//
// /**
//  * Time to Interactive (TTI) 측정을 시작합니다.
//  */
// export function startTTI() {
//   console.time(metricTTIKey);
//   ttiStartTime = Date.now();
//   ttiCheckMetrics = false;
//   timerStarted = true;
// }
//
// /**
//  * Time to Interactive (TTI) 측정을 종료합니다.
//  * TTI 측정 원리의 경우 FCP 이후 해당 페이지의 최하위 컴포넌트가 모두 렌더링되었을 때까지의 시간을 TTI로 측정합니다.
//  * TTI 시작의 경우 앱 실행시 1회 FCP 완료 이후부터 시작이 기록되며
//  * TTI 종료의 경우 최하위 컴포넌트에서 해당 method가 실행되어야 합니다.
//  * 참고로 method가 react-router-dom에 의해 재호출되더라도
//  * FCP에서 start log가 발생하지 않았기 때문에 중복 로깅이 되지 않습니다.
//  */
// export function stopTTI() {
//   if (!timerStarted) {
//     return;
//   }
//
//   if (ttiCheckMetrics) {
//     appInsights.trackTrace({
//       message: "TTI 1회 이상 측정 case 발생",
//       severityLevel: SeverityLevel.Warning,
//       // 어느 페이지인지, 모바일인지 등 도움 될 만한 정보 수집
//       properties: {
//         Href: window.location.href,
//         Pathname: window.location.pathname,
//         Search: window.location.search,
//         WindowInnerWidth: window.innerWidth,
//         WindowInnerHeight: window.innerHeight,
//       },
//     });
//     return;
//   }
//
//   ttiEndTime = Date.now();
//   const delta = ttiEndTime - ttiStartTime;
//   console.timeEnd(metricTTIKey);
//   console.log("직접 구한 stopwatch와 console.time 비교", delta);
//
//   appInsights.trackEvent({
//     name: metricTTIKey,
//     properties: {
//       Href: window.location.href,
//       Pathname: window.location.pathname,
//       Search: window.location.search,
//       Duration: delta,
//     },
//   });
//
//   ttiCheckMetrics = true;
//   timerStarted = false;
// }
